module.exports = __webpack_public_path__ + "media/images/emoticons/penguin-30d6b5e5ea49fd45ad72f3706615844a.gif";